import React, { useState, useEffect } from 'react';
import Styles from './MaoNaRoda25Condicoes.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import ModalSeguros from '@/components/molecules/ModalSeguros';

function MaoNaRoda25Condicoes() {
  const [showModalSantander, setShowModalSantander] = useState(false);
  const tituloModalSantander = 'Condições Contratuais: Santander Auto';
  // exemplo para doc antigos
  // const docsSantander = [
  //   {
  //     titulo: 'Condições Contratuais: Santander Auto',
  //     descricao: `Vigência: de 03/11/2022 a 26/10/2023`,
  //     link: 'assets/seguro/pdf/03-11-22-em-diante.pdf',
  //   },
  //   {
  //     titulo: 'Condições Contratuais: Santander Auto',
  //     descricao: `Vigência: de 26/08/2021 a 02/11/2022`,
  //     link: 'assets/seguro/pdf/26-08-21-em-diante.pdf',
  //   },
  // ];

  useEffect(() => {
    if (showModalSantander) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModalSantander]);

  return (
    <>
      <section id="seguro-auto-condicoes">
        <ContainerHome24>
          <div className="condicoes-contain">
            <img
              src="assets/seguro-auto-25/carros.svg"
              alt="Seguro Mão na Roda para carro, moto e veículos utilitários financiados"
              className="condicoes-contain-img"
            />
            <div className="condicoes-contain-conteudo">
              <h2 className="condicoes-contain-titulo">Conheça nossas condições contratuais</h2>
              <div className="condicoes-contain-cards">
                <div className="cards-condicao">
                  <a
                    href="assets/mao-na-roda-25/pdf/condicoes-gerais-vigente-18122025.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">Vigência: de 18/12/2025 em diante</p>
                    </div>
                  </a>
                  <a
                    href="assets/mao-na-roda-25/pdf/condicoes-gerais-11122025-ate-17122025.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 11/12/2025 a 17/12/2025
                      </p>
                    </div>
                  </a>
                  <a
                    href="assets/mao-na-roda-25/pdf/condicoes-gerais-21012025-ate-10122025.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 21/01/2025 a 10/12/2025
                      </p>
                    </div>
                  </a>
                  <a
                    href="assets/mao-na-roda-25/pdf/condicoes-contratuais-santander-auto-27102023-ate-20012025.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 27/10/2023 a 20/01/2025
                      </p>
                    </div>
                  </a>
                </div>
                {/* <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModalSantander(true);
                  }}
                  className="link-condicoes-antigas"
                >
                  Exibir condições mais antigas
                </div> */}
              </div>
            </div>
          </div>
        </ContainerHome24>
      </section>
      {showModalSantander && (
        <ModalSeguros
          setShowModal={setShowModalSantander}
          tituloModal={tituloModalSantander}
          docs={docsSantander}
        />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default MaoNaRoda25Condicoes;
